export default {
    pageTitle: 'MACRO-TREND - TREND-OVERVIEW',
    title: 'Macro-trend'
}
